import { lt, showSuccessAlert } from '@mews/framework';
import { CommanderFormProps, useDialogForm, useHandledDialogFormControls } from '@mews-commander/form';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { preparePaymentPolicyValues } from '../../../utils';
import { CentralPaymentPolicyFormContent } from '../CentralPaymentPolicyFormContent';
import { resolver } from '../schema';
import { useGetInitialFormValues } from './useGetInitialFormValues';

const CreateCentralPaymentPolicyFormContent = (props: CommanderFormProps) => {
    const { formValues } = useGetInitialFormValues();

    const { mutateAsync } = useRepositoryMutation('portfolioCentralPaymentPolicies', 'add', {
        transformParams: preparePaymentPolicyValues,
        onSuccess: () => {
            showSuccessAlert({
                title: lt('PaymentPolicyCreatedSuccessMessage'),
            });
        },
        invalidateQueries: {
            portfolioCentralPaymentPolicies: ['getOverviewEntries', 'getAll'],
        },
    });

    const { renderFormContent } = useHandledDialogFormControls({
        ...props,
        defaultValues: formValues,
        onSubmit: async (values) => mutateAsync(values),
        resolver,
    });

    return renderFormContent(<CentralPaymentPolicyFormContent />);
};

export const useCreateCentralPaymentPolicyDialogForm = () =>
    useDialogForm({
        id: 'create-central-payment-policy',
        title: lt('PaymentPolicyNew'),
        saveLabel: lt('Create'),
        renderForm: (props) => <CreateCentralPaymentPolicyFormContent {...props} />,
    });
